import { render, staticRenderFns } from "./StopLoss.vue?vue&type=template&id=caff2fca&scoped=true&"
import script from "./StopLoss.vue?vue&type=script&lang=js&"
export * from "./StopLoss.vue?vue&type=script&lang=js&"
import style0 from "./StopLoss.vue?vue&type=style&index=0&id=caff2fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caff2fca",
  null
  
)

export default component.exports